import { render, staticRenderFns } from "./KPICardCommon.vue?vue&type=template&id=a45e6ff6&scoped=true"
import script from "./KPICardCommon.vue?vue&type=script&lang=js"
export * from "./KPICardCommon.vue?vue&type=script&lang=js"
import style0 from "./KPICardCommon.vue?vue&type=style&index=0&id=a45e6ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45e6ff6",
  null
  
)

export default component.exports